'use client';

import {
  Dialog,
  DialogActionButton,
  DialogCloseButton,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogSubTitle,
  DialogTitle,
} from '@pickleballinc/ui/components/ui/dialog-v2';

interface UnfollowConfirmModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function UnfollowConfirmModal({ open, onOpenChange, onConfirm }: UnfollowConfirmModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='!max-w-[400px]'>
        <DialogHeader>
          <DialogTitle>Unfollow this player?</DialogTitle>
          <DialogSubTitle>
            Unfollowing this player will remove them from your following list. You can follow them
            again at any time.
          </DialogSubTitle>
        </DialogHeader>
        <DialogFooter>
          <DialogCloseButton>Cancel</DialogCloseButton>
          <DialogActionButton onClick={onConfirm}>Confirm</DialogActionButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
